type DashboardChartData = {
  readonly inProgress: number[];
  readonly completed: number[];
  readonly declined: number[];
};

export const transformMetricsForDisplay = (data: DashboardChartData): DashboardChartData => {
  const declined = data.declined;

  const completed = declined.map((metricValue, index) => {
    const completedMetricValue = data.completed[index];
    return metricValue + completedMetricValue;
  });

  const inProgress = completed.map((metricValue, index) => {
    const inProgresMetricValue = data.inProgress[index];
    return metricValue + inProgresMetricValue;
  });

  return {
    inProgress,
    completed,
    declined,
  };
};
